import { useContext } from "react";
import { useSelector } from "react-redux";
import { AppNotification } from "@planzone/dto";
import { CoreContext } from "./context";

interface ViewModel {
  notifications: AppNotification[];
  canDisplayNotifications: boolean;
  dismissNotification(key: string): void;
}

function useAppNotifications(): ViewModel {
  const { selector, eventDispatcher } = useContext(CoreContext);

  return {
    notifications: useSelector(selector.getAppNotifications),
    canDisplayNotifications: useSelector(selector.canDisplayAppNotifications),
    dismissNotification: eventDispatcher.dispatchAppNotificationDismissal,
  };
}

export { useAppNotifications };
